module.exports = __webpack_public_path__ + "img/puntob.43bd527e.png";